import './base/';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import slider from './slider.js';
import 'magnific-popup';
import './autocomplete';

const $win = $(window);
const $doc = $(document);

const $productSelect = $('#product-select');
const productLocked = $('.section__inner--locked').length;

var isMobile = false;
if (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  )
)
  isMobile = true;

if (isMobile) {
  $('body').addClass('is-mobile');
  closeDropdown();
}

$('.form__cols input').each(function() {
  if ($(this).val().length > 0) {
    $(this).addClass('valid');
  }
});

// slider($slider, dots, arrows)
// slider($('.collection__items'), true);

$('.list-photos, .product__media').each(function() {
  $(this).magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1]
    }
  });
});

$('.list-precautions a, .product__contact .btn').each(function() {
  $(this).magnificPopup({
    type: 'inline',
    showCloseBtn: false
  });
});

$doc
  .on('click', '.list-precautions a', function(e) {
    e.preventDefault();
    var activeClass = 'current';

    $('.list-precautions + .btn').attr('href', $(this).attr('href'));

    $(this)
      .parent()
      .addClass(activeClass)
      .siblings()
      .removeClass(activeClass);
  })

  .on('click', '.tabs__nav a', function(e) {
    e.preventDefault();
    var link = $(this).attr('href');
    var $linkParent = $(this).parent();
    var $tab = $(link);
    var activeClass = 'current';

    $tab
      .add($linkParent)
      .addClass(activeClass)
      .siblings()
      .removeClass(activeClass);
  })
  .on('click', '.btn-close, mfp-close', function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  })
  .on('touchend', '.accordion .accordion__head', function() {
    let $accHead = $(this);
    let $acc = $accHead.closest('.accordion__section');

    $accHead.next().slideToggle();

    $acc
      .toggleClass('expanded')
      .siblings()
      .removeClass('expanded')
      .find('.accordion__body')
      .slideUp();
  })
  .on('click', 'body:not(.template-customer) .form__trigger, .form__trigger-popup', function(e) {
    e.preventDefault();
    let id = $(this).data('href');

    $(id)
      .show()
      .siblings()
      .hide();
  })
  .on('click', '.menu-item-closed > a', function(e) {
    e.preventDefault();

    $(this)
      .parent()
      .removeClass('menu-item-closed')
      .siblings('.menu__item--has-dropdown')
      .addClass('menu-item-closed');
  })
  .on('click', '.nav-trigger', function(e) {
    e.preventDefault();

    $('.wrapper').toggleClass('nav-expanded');
    closeDropdown();
  })
  .on('click', '.search-trigger', function(e) {
    e.preventDefault();

    $('.wrapper').toggleClass('search-expanded');
    closeDropdown();
  })
  .on('touchend', '.hidden-mobile-up', function(e) {
    e.preventDefault();

    $(this).toggleClass('expanded');
    $(this)
      .next()
      .find('.form__body')
      .slideToggle();
  })
  .on('touchend', '.hidden-tablet-up', function(e) {
    e.preventDefault();

    $(this).toggleClass('expanded');
    $('.btn-wrapper').slideToggle();
  })
  .on('change', '#itemsNumber', function(e) {
    e.preventDefault();
    var $this = $(this);

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: 'attributes[paginate]=' + $this.val()
    }).done(function(data) {
      location.reload();
    });
  })
  .on('click', '.menu__item--has-dropdown > a', function(event) {
    event.stopPropagation();
  })
  .on('change', '.product-details--colors input:checked', function(event) {
    $('.product .form__row--color input')
      .val($(this).val())
      .addClass('valid');

    changeVariant();

    if (!productLocked) {
      checkIsValid();
    }
  })
  .on('change', '.product-details--size select', function(event) {
    $('.product .form__row--size input')
      .val($(this).val())
      .addClass('valid');

    changeVariant();

    if (!productLocked) {
      checkIsValid();
    }
  })
  .on('submit', '.product__form', function(e) {
    checkIsValid();

    $('.form__cols input').each(function() {
      if (!$(this).hasClass('valid')) {
        e.preventDefault();
      }
    });
  })
  .on('change', $productSelect, function(e) {
    if (!productLocked) {
      if ($(this).find('option:checked').length < 2) {
        $('.product').addClass('disabled');
        $('.available').hide();
        $('.unavailable').show();
      } else {
        $('.product').removeClass('disabled');
        $('.unavailable').hide();
        $('.available').show();
      }
    }
  });

$('body').on('click', function() {
  if (isMobile) {
    $('.menu__item--has-dropdown:not(.menu-item-closed)').addClass('menu-item-closed');
  }
});

function changeVariant() {
  var option_target = '';

  $('.product .form__row--color input, .product .form__row--size input').each(function() {
    var $this = $(this);
    var dataIndex = $this.data('index');
    var eleValue = $this.val();
    option_target += `[data-option-${dataIndex}="${eleValue}"]`;
  });

  var selectedVal = $productSelect.find(option_target).val();
  $productSelect.val(selectedVal);

  let sku = $productSelect.find('option:selected').data('sku');
  let price = $productSelect.find('option:selected').data('price');
  let priceMin = $('[data-price_min]').data('price_min');

  if (sku != undefined) {
    $('.product .product__sku').text(sku);
  } else {
    $('.product .product__sku').text();
  }

  if (!productLocked) {
    if (price != undefined) {
      $('.product .price').html(price);
    } else {
      $('.product .price').text(priceMin);
    }
  }
}

function checkIsValid() {
  let isValid = true;

  $('.form__cols input').each(function() {
    if (!$(this).val().length > 0) {
      $(this)
        .closest('.product')
        .addClass('error');
      isValid = false;
    }
  });

  if (isValid) {
    $('.product').removeClass('error');
  }
}

function closeDropdown() {
  $('.menu__item--has-dropdown').each(function() {
    $(this).addClass('menu-item-closed');
  });
}

$('.section-news .section__body, .search-popup').mCustomScrollbar();

$('.scroll-top').on('click', function(e) {
  e.preventDefault();

  smoothScroll(this);
});

var smoothScroll = function(linkDOM) {
  linkDOM = linkDOM || location;

  if (linkDOM.hash && (location.pathname == linkDOM.pathname || location.hostname == linkDOM.hostname)) {
    var target = $(linkDOM.hash);

    if (target.length) {
      $('html,body').animate(
        {
          scrollTop: target.offset().top //Scroll to position
        },
        1000
      );

      return false;
    }
  }
};
